import React from 'react';

export default function GallerySectionStyle2({ data }) {
  const clientReviews = [
    {
      title: "Client Review 1",
      cases: [
        {
          before: "/images/gallery/pt_photos/pt_1/2.jpeg",
          after: "/images/gallery/pt_photos/pt_1/1.jpg",
          diagnosis: "Crowding, Class II",
          goal: "Alignment of the upper and lower jaw, 7-7",
          duration: "12 Months",
        },
        {
          before: "/images/gallery/pt_photos/pt_1/4.jpeg",
          after: "/images/gallery/pt_photos/pt_1/3.jpg",
          diagnosis: "Deep Bite",
          goal: "Correct bite and improve smile aesthetics",
          duration: "8 Months",
        },
      ],
    },

    {
      title: "Client Review 2",
      cases: [
        {
          before: "/images/gallery/pt_photos/pt_2/2.jpeg",
          after: "/images/gallery/pt_photos/pt_2/1.jpg",
          diagnosis: "Spacing",
          goal: "Close spacing and align teeth",
          duration: "10 Months",
        },
        {
          before: "",
          after: "/images/gallery/pt_photos/pt_2/3.jpg",
          diagnosis: "Spacing",
          goal: "Close spacing and align teeth",
          duration: "10 Months",
        },

      ],
    },

    {
      title: "Client Review 3",
      cases: [
        {
          before: "/images/gallery/pt_photos/pt_3/1.jpeg",
          after: "/images/gallery/pt_photos/pt_3/4.jpg",
          diagnosis: "Crowding",
          goal: "Straighten upper and lower teeth",
          duration: "11 Months",
        },
        {
          before: "/images/gallery/pt_photos/pt_3/2.jpeg",
          after: "/images/gallery/pt_photos/pt_3/3.jpg",
          diagnosis: "Open Bite",
          goal: "Improve bite closure and smile aesthetics",
          duration: "15 Months",
        },
      ],
    },
    {
      title: "Client Review 4",
      cases: [
        {
          before: "/images/gallery/pt_photos/pt_4/1.jpeg",
          after: "/images/gallery/pt_photos/pt_4/2.jpg",
          diagnosis: "Spacing",
          goal: "Close spacing and align teeth",
          duration: "10 Months",
        },

      ],
    },
    {
      title: "Client Review 5",
      cases: [
        {
          before: "/images/gallery/pt_photos/pt_5/1.jpg",
          after: "/images/gallery/pt_photos/pt_5/2.jpg",
          diagnosis: "Spacing",
          goal: "Close spacing and align teeth",
          duration: "10 Months",
        },

      ],
    },
    {
      title: "Client Review 6",
      cases: [
        {
          before: "/images/gallery/pt_photos/pt_6/2.jpg",
          after: "/images/gallery/pt_photos/pt_6/1.jpg",
          diagnosis: "Spacing",
          goal: "Close spacing and align teeth",
          duration: "10 Months",
        },

      ],
    },
    {
      title: "Client Review 7",
      cases: [
        {
          before: "/images/gallery/pt_photos/pt_7/1.jpeg",
          after: "/images/gallery/pt_photos/pt_7/2.jpg",
          diagnosis: "Spacing",
          goal: "Close spacing and align teeth",
          duration: "10 Months",
        },

      ],
    },
  ];
  return (
    <div className="container">
  <div className="cs_gallery_grid"  data-aos="fade-up"
  data-aos-duration="1200"
  data-aos-offset="200">
    <div className="row">
      {clientReviews.map((review, index) => {
        const beforeImages = review.cases.filter(item => item.before);
        const afterImages = review.cases.filter(item => item.after);

        // Image width logic
        const beforeColClass =
          beforeImages.length === 1 && afterImages.length === 1
            ? "col-12"
            : "col-12 col-md-6 pe-2";

        const afterColClass =
          beforeImages.length === 1 && afterImages.length === 1
            ? "col-12"
            : "col-12 col-md-6 pe-2";

        return (
          <div
            key={index}
            className={`mb-5 ${
              index < 3 ? "col-lg-12" : "col-lg-6"
            }`}
          >
            <div className="case-card">
              <div className="row g-3 align-items-start">
                {/* BEFORE */}
                <div className="col-12 col-md-6 before-group">
                  <div className="row g-2 mx-2 justify-content-center">
                    {beforeImages.map((item, i) => (
                      <div key={i} className={beforeColClass}>
                        <div className="case-image position-relative">
                          <img src={item.before} alt="Before" />
                        </div>
                      </div>
                    ))}

                    {beforeImages.length > 0 && (
                      <div className="col-12">
                        <div className="case-label text-center mt-3">
                          <span className="before-after">BEFORE</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* AFTER */}
                <div className="col-12 col-md-6">
                  <div className="row g-2 mx-2 justify-content-center">
                    {afterImages.map((item, i) => (
                      <div key={i} className={afterColClass}>
                        <div className="case-image position-relative">
                          <img src={item.after} alt="After" />
                        </div>
                      </div>
                    ))}

                    {afterImages.length > 0 && (
                      <div className="col-12">
                        <div className="case-label text-center mt-3">
                          <span className="before-after">AFTER</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <hr />

              <div
                className="case-content d-flex flex-wrap"
                style={{ gap: "20px" }}
              >
                <div
                  className="d-flex align-items-center"
                  style={{ gap: "10px" }}
                >
                  <h6 className="mb-0">DIAGNOSIS:</h6>
                  <p className="mb-0">{review.cases[0]?.diagnosis}</p>
                </div>

                <div
                  className="d-flex align-items-center"
                  style={{ gap: "10px" }}
                >
                  <h6 className="mb-0">TREATMENT DURATION:</h6>
                  <p className="mb-0">{review.cases[0]?.duration}</p>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
</div>
  );
}
